import React, { useState, useEffect } from "react";
import { Dropdown } from "react-bootstrap";
import { AiFillEye } from "react-icons/ai";
import { BsThreeDots } from "react-icons/bs";
import { FiEdit, FiSearch, FiTrash } from "react-icons/fi";

import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import DeleteModal from "../../commonComponent/DeleteModal";
import Loader from "../../commonComponent/Loader";
import SquareAvatar from "../../commonComponent/SquareAvatar";
import { useAuth } from "../../Context/AuthContext";
import {
  assignGroupToProvider,
  deleteGroupService,
  getDefaultGroup,
  getGroupShareLink,
  getMyGroupList,
  setDefaultGroup,
  updateActivityCountService,
  updateVisitCountService,
} from "../../services/GroupService";
import {
  changeDateFormat,
  showToastError,
  showToastSuccess,
  sortArrLatest,
} from "../../Utils/Helper";
import ShareLinkModal from "../carePlan_/ShareLinkModal";
import ApiConfig from "../../config/ApiConfig";
import { toast } from "react-toastify";
import { addArchiveCareplan } from "../../services/CreateCarePlanService";
import AssignProvidersModal from "../activeProgram/AssignToProvidersModal";
import { toastMsg } from "../../Utils/AllConstant";
import { useTabList } from "../../Context/TabListContext";

const GroupLists = () => {
  const navigate = useNavigate();
  const { isAdmin } = useAuth();
  const [groupLists, setGroupLists] = useState([]);
  const [filterdata, setFilterData] = useState([]);
  const [isLoading, setLoader] = useState(true);
  const [listTabs, setListTabs] = useState({
    active: true,
    archived: false,
    default: false,
    assigned: false,
  });
  const [selectedGroup, setSelectedGroup] = useState();
  const [groupProviders, setGroupProviders] = useState([]);
  const [gID, setGID] = useState("");
  const [linkInput, setLinkInput] = useState("");
  const { groupTabList, setGroupTabList } = useTabList();

  // const { tab } = loctation?.state;

  useEffect(() => {
    if (groupTabList === "default") {
      setListTabs((prev) => {
        return { prev, default: true };
      });
      getDefaultGroupList();
    } else if (groupTabList === "assigned") {
      setListTabs((prev) => {
        return { prev, assigned: true };
      });
      getGroupLists("&myassign=true");
    } else {
      setListTabs((prev) => {
        return { prev, active: true };
      });
      getGroupLists();
    }
    setGroupTabList("");
  }, []);

  // useEffect(() => {
  //   if(tab === 'default') {
  //     setListTabs((prev) => {
  //       return { prev, default: true };
  //     });
  //     getDefaultGroupList();
  //   }else{
  //     setListTabs((prev) => {
  //       return { prev, active: true };
  //     });
  //   }

  // }, []);

  const getShareLink = async (groupId) => {
    try {
      const response = await getGroupShareLink(groupId);
      setLoader(false);

      if (response.status === 200) {
        setLinkInput(response?.data);
      } else {
        alert(response?.data || response.message);
      }
    } catch (error) {
      setLoader(false);
      error?.data?.data && alert(error?.data?.data || error.data?.message);
    }
  };

  const makeDefault = async (groupId) => {
    try {
      const response = await setDefaultGroup(groupId);
      if (response.status === 200) {
        // document.getElementById("checkbox").checked = true;
        listTabs.default ? getDefaultGroupList() : getGroupLists();
        showToastSuccess(`Group Added to Default`);
        // renderListRow();
      } else {
        showToastError(
          response?.data || response.message || "Some error occurred"
        );
      }
    } catch (error) {
      console.log(error);
    }
  };

  // To get All default program list
  const getDefaultGroupList = async () => {
    setLoader(true);
    setFilterData([]);

    try {
      const response = await getDefaultGroup();

      if (response.status === 200) {
        setGroupLists(response?.data?.data);
        if (response?.data?.data?.length > 0)
          setFilterData(sortArrLatest(response?.data?.data));
        setLoader(false);
        // Check whether to is from create program or not if yes then will navigate to active program tab module
        // if (newCreatedProgramId) {
        //   const program = response?.data?.data?.find(item => item._id === newCreatedProgramId)
        //   program && navigate("/activeprogram", { state: { program, isFromCreate: true } });
        // } else {
        //   if (!userId) {
        //     navigate(`/activeprogramlist/${response?.data?.data?.[0]._id}`, { replace: true })
        //   }
        // }
      }
    } catch (error) {
      setLoader(false);
    }
  };

  // Server Methods
  const getGroupLists = async (searchWord) => {
    setLoader(true);
    setFilterData([]);
    try {
      const response = await getMyGroupList(searchWord);
      setLoader(false);
      if (response.status === 200) {
        setGroupLists(response?.data?.data);
        if (response?.data?.data?.length > 0)
          setFilterData(sortArrLatest(response?.data?.data));
        // if (props.selectedGroup == "")
        //   props.onselectgroup(response.data.data[0]);
        // else
        //   props.onselectgroup(
        //     response.data.data.filter(
        //       (dt) => dt._id == props.selectedGroup._id
        //     )[0]
        //   );
        // dispatch(setGroupList(response.data.data));
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  };

  const getArchiveList = async (searchWord) => {
    setLoader(true);
    try {
      const [activeList, assignedList] = await Promise.all([
        getMyGroupList(searchWord),
        getMyGroupList("&myassign=true"),
      ]);
      const response = [...activeList.data.data, ...assignedList.data.data];
      if (activeList.status === 200 && assignedList.status === 200) {
        setGroupLists(response);
        if (response.length > 0) setFilterData(sortArrLatest(response));
        setLoader(false);
      }
    } catch (error) {
      console.log(error);
    }
  };


  const addArchive = async (groupId) => {
    let parms = {
      Id: groupId,
      Type: "group",
    };
    try {
      if (parms) {
        // console.log("careplanId", groupId);
        const response = await addArchiveCareplan(parms);
        if (!response?.data?.status === 200) {
          toast.error(`status:${response?.data?.status}`);
        }
        if (response?.data?.data?.isArchive === false) {
          showToastSuccess(`Group Unarchived`);
        } else {
          showToastSuccess(`Group Archived`);
        }
        // setFilterData(response?.data?.data);
        // showToastSuccess(`Group Archived`);
        // getGroupLists();
        if (listTabs.archived) {
          getArchiveList();
        }
        if (listTabs.assigned) {
          getGroupLists("&myassign=true");
        }
        if (listTabs.default) {
          getDefaultGroupList();
        }
        if (listTabs.active) {
          getGroupLists();
        }
      } else {
        toast.error("Group Id is not available");
      }
    } catch (response) {
      toast.error(response?.data?.data);
    }
  };

  const handleClick = (item) => {
    updateGroupVisit(item)
    navigate("/groupactivities", {
      state: { selectedGroup: item, isFromCreate: false },
    });
  };

  const updateGroupVisit = async (item) => {
    if (!item._id) {
      return;
    }

    try {
      const visitCountPromise = updateVisitCountService(item._id.toLowerCase());
      const activityCountPromise = updateActivityCountService(item._id.toLowerCase());
      await Promise.all([visitCountPromise, activityCountPromise]);
    } catch (error) {
      console.error('Failed to update visit count:', error.message);
    }
  };

  const renderListRow = (item) => {
    // console.log(item, "item")
    let image = item?.groupImage;
    if (item?.groupImage.includes("https")) {
      let htImage = item?.groupImage?.split("/");
      image = htImage[htImage?.length - 1];
    }
    return (
      <tr key={item._id} className={"pointer"}>
        <td className="text-muted" onClick={() => handleClick(item)}>
          <SquareAvatar
            //   src={item.groupImage}
            src={ApiConfig.ImageUrl + "groups/" + item.createdBy + "/" + image}
            className="member_listimage squre_image2"
            alt={item?.groupName}
            loading="lazy"
          />
        </td>
        <td
          className="text-muted"
          onClick={() => handleClick(item)}
        >{`${item.groupName}`}</td>
        <td
          className="text-muted"
          onClick={() => handleClick(item)}
        >{`${item.description}`}</td>
        <td className="text-muted" onClick={() => handleClick(item)}>
          {changeDateFormat(item.createdAt)}
        </td>
        <td
          className="text-muted"
          onClick={() => handleClick(item)}
        >{`${item?.groupMembers?.length}`}</td>

        {/* <td className="text-muted">{format(parseISO(item.endDate), 'MMM d, yyyy')}</td> */}
        {/* <td className="text-muted">{`${item.programMembers?.length}`}</td> */}
        <td
          className="text-muted fw-bold text-left overflow-visible"
          style={{ cursor: "pointer" }}
        >
          {/* <span className="mb-0" data-bs-toggle="tooltip" data-bs-placement="top" title="View" onClick={() => navigate("/groupinfo", { state: { selectedGroup: item } })}><MdPreview size="1.5em" /> </span> */}
          {/* <span className="mb-0" data-bs-toggle="tooltip" data-bs-placement="top" title="Edit" onClick={() => navigate("/groupactivities", { state: { selectedGroup: item, isFromCreate: false } })}><RiEdit2Fill size="1.5em" /></span> */}
          <div className="d-flex gap-1">
            <button
              onClick={() =>
                navigate("/groupactivities", {
                  state: { selectedGroup: item, isFromCreate: false },
                })
              }
              className="btn btn-light"
              style={{
                backgroundColor: "rgba(31, 126, 120, 0.05)",
                color: "rgba(31, 126, 120)",
              }}
            >
              <AiFillEye className="mb-1" />
            </button>
            {!item.isArchive && (
              <button
                onClick={() =>
                  navigate("/groupupdate", {
                    state: { user: item, tab: listTabs },
                  })
                }
                className="btn btn-light"
                style={{
                  backgroundColor: "rgba(31, 126, 120, 0.05)",
                  color: "rgba(31, 126, 120)",
                }}
              >
                <FiEdit className="mb-1" />{" "}
              </button>
            )}
            <button
              data-bs-toggle={item.isArchive ? "modal" : ""}
              data-bs-target={item.isArchive ? "#deleteGroup" : ""}
              onClick={() => {
                if (item.isArchive) {
                  setSelectedGroup(item);
                  return setGID(item._id);
                } else {
                  return addArchive(item._id);
                }
              }}
              className="btn btn-light"
              style={{
                backgroundColor: "rgba(31, 126, 120, 0.05)",
                color: "rgba(31, 126, 120)",
              }}
            >
              <FiTrash className="mb-1" />{" "}
            </button>

            <Dropdown>
              <Dropdown.Toggle
                variant="light"
                className="custom"
                id="dropdown-basic"
                style={{
                  backgroundColor: "rgba(31, 126, 120, 0.05)",
                  color: "rgba(31, 126, 120)",
                }}
              >
                <BsThreeDots className="icon" />
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {/* <Dropdown.Item onClick={() => navigate("/groupupdate", { state: { user: item } })}>Edit</Dropdown.Item> */}
                {/* <Dropdown.Item
                  data-bs-toggle="modal"
                  data-bs-target="#assigngroupmodal1"
                  onClick={() => {
                    setSelectedProgram(item);
                    getGroupLists(item._id);
                  }}
                >
                  Assign to team
                </Dropdown.Item>
                {listTabs.assigned ? (
                  <Dropdown.Item
                    href="#/action-2"
                    data-bs-toggle="modal"
                    data-bs-target="#assignmembermodal1"
                    onClick={() => {
                      setSelectedProgram(item);
                      setProgramMembers(item.programMembers);
                      setOpen(true);
                      setAssignedModal(true);
                    }}
                  >
                    Assign to member
                  </Dropdown.Item>
                ) : (
                  <Dropdown.Item
                    href="#/action-2"
                    data-bs-toggle="modal"
                    data-bs-target="#assignmembermodal1"
                    onClick={() => {
                      setSelectedProgram(item);
                      setProgramMembers(item.programMembers);
                      setOpen(true);
                    }}
                  >
                    Assign to member
                  </Dropdown.Item>
                )} */}
                {isAdmin ? (
                  <Dropdown.Item
                    href="#/action-1"
                    data-bs-toggle={
                      !(item?.careTeam?.length > 0) ? "modal" : ""
                    }
                    data-bs-target={
                      !(item?.careTeam?.length > 0)
                        ? "#assigngroupproviders"
                        : ""
                    }
                    onClick={() => {
                      if (item?.careTeam?.length > 0) {
                        showToastError(
                          "Program Already Assigned to another Provider"
                        );
                      } else {
                        setSelectedGroup(item);
                        setGroupProviders(item?.careTeam);
                      }
                    }}
                  >
                    Assign to providers
                  </Dropdown.Item>
                ) : null}
                {isAdmin ? (
                  <Dropdown.Item
                    href="#/action-2"
                    onClick={() => makeDefault(item._id)}
                  >
                    {item.default === true
                      ? "Remove as Default"
                      : "Make Default"}
                  </Dropdown.Item>
                ) : null}
                <Dropdown.Item
                  href="#/action-3"
                  data-bs-toggle="modal"
                  data-bs-target="#shareModal"
                  onClick={() => getShareLink(item._id)}
                >
                  Share Link
                </Dropdown.Item>
                {/* <Dropdown.Item
                  href="#/action-4"
                  data-bs-toggle="modal"
                  data-bs-target="#deleteGroup"
                  onClick={() => setGID(item._id)}
                >
                  Delete
                </Dropdown.Item> */}
                {item.isArchive === true ? (
                  <Dropdown.Item
                    href="#/action-6"
                    onClick={() => {
                      return addArchive(item._id);
                    }}
                  >
                    Unarchive
                  </Dropdown.Item>
                ) : null}
              </Dropdown.Menu>
            </Dropdown>
          </div>
          <DeleteModal
            onCancel={(e) => {
              e.stopPropagation();
            }}
            title={"Delete"}
            content1={"Are you sure you want to delete"}
            content2={"this group?"}
            modalId={"deleteGroup"}
            button2={"No"}
            button1={"Yes"}
            onDelete={() => {
              if (!isAdmin && item?.careTeam?.length > 0) {
                setSelectedGroup(item);
                updateGroup(item.careTeam);
              } else {
                deleteGroup(item._id);
              }
            }}
          />
        </td>
      </tr>
      // </div>
    );
  };

  const renderLoader = () => {
    return (
      <Loader
        visible={isLoading}
        emptyTextKey={"noAnyGroup"}
        style={{ top: 0, position: "relative" }}
      />
    );
  };

  const ArchivedrenderList = () => {
    const archivedItems = filterdata?.filter((item) => item.isArchive);

    return <tbody>{archivedItems.map((item) => renderListRow(item))}</tbody>;
  };

  const DefaultrenderList = () => {
    const defaultItems = filterdata?.filter((item) => item.default);
    return <tbody>{defaultItems.map((item) => renderListRow(item))}</tbody>;
  };
  const AssignedrenderList = () => {
    const assignedItems = filterdata?.filter((item) => !item.isArchive);

    return <tbody>{assignedItems.map((item) => renderListRow(item))}</tbody>;
  };
  const renderList = () => {
    const nonArchivedItems = filterdata?.filter((item) => !item.isArchive);

    return <tbody>{nonArchivedItems.map((item) => renderListRow(item))}</tbody>;
  };

  // const onGroupSearch = async (e) => {
  //   let searchWord = e.target.value;
  //   const result = groupLists?.filter((value) => {
  //     if (value) {
  //       return value?.groupName
  //         ?.toLowerCase()
  //         ?.includes(searchWord?.toLowerCase());
  //     }
  //   });

  //   if (searchWord === "") {
  //     setFilterData(groupLists);
  //     // getGroupLists(searchWord);
  //   } else {
  //     setFilterData(result);
  //   }
  // };

  const onGroupSearch = async (e) => {
    const searchWord = e.target.value.toLowerCase();

    const result = groupLists?.filter((value) => {
      return value?.groupName?.toLowerCase().includes(searchWord) || false;
    });

    setFilterData(searchWord === "" ? groupLists : result);
  };

  const updateGroup = async (list) => {
    let params = {
      groupId: selectedGroup._id,
      providerId: list[0],
    };
    if (params) {
      try {
        const response = await assignGroupToProvider(params);
        if (response) {
          showToastSuccess(toastMsg.updateGroup);
          getGroupLists();
          // props.onRefresh()
          setGroupProviders([]);
          // setSelectedGroupMembers([]);
        }
        setLoader(false);
      } catch (error) {
        setLoader(false);
        console.log(error);
      }
    } else {
      toast.error("Error occurred");
    }
  };

  const deleteGroup = async (id) => {
    try {
      const response = await deleteGroupService(id);
      if (response) {
        showToastSuccess(response?.data || "Group deleted successfully.");
        // onRefresh();
        // navigate(-1);
        // getSessionById()
        listTabs.archived ? getGroupLists() : getDefaultGroupList();
      } else {
        showToastError(
          response?.data || response.message || "Some error occurred"
        );

        // navigate(-1);
      }
    } catch (error) {
      showToastError(
        error?.data?.data || error.data?.message || "Some error occurred"
      );
      // navigate(-1);
    }
  };

  const renderSearchHeader = () => {
    return (
      <div className="d-flex mt-3 mb-2 ">
        <div className="w-50">
          <h4 className=" headFont ">Groups</h4>
          <p className="resFont">See how your groups are doing</p>
        </div>
        <div className="w-50 d-flex">
          {/* <div className="actsearch_simple me-2">
                <FiSearch className="boxicon" />
                <input
                    placeholder="Search for group..."
                    className="ms-2"
                    // value={searchText}
                    onChange={(e) => onGroupSearch(e)} />
                </div> */}
          {/* <div className="me-2">
                <Filter />
                </div> */}
          {/* <Link
                to="/groupadd"
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                title="Add Group"
                className="btn btn-primary btn-custom">
                <AiOutlinePlus className="me-2" /> Create New Group
                </Link> */}

          {/* <GroupActivityButton className='btn btn-primary btn-custom' onClick={()=>navigate("/groupadd")}> Create New Group</GroupActivityButton> */}
        </div>
      </div>
    );
  };

  return (
    <>
      {renderSearchHeader()}
      <ShareLinkModal link={linkInput} />
      {/* <AddMemberModal addMember={updateGroup} members={user?.groupMembers} setMembers={setSelectedGroupMembers} /> */}
      <div className="mt-3">
        <div className="d-flex justify-content-between border-bottom align-items-center">
          <div className="custom-tabs d-flex">
            <b
              onClick={() => {
                setListTabs((prev) => {
                  return { prev, active: true };
                });
                getGroupLists();
              }}
              className={`px-3 border-bottom tab mb-0  ${
                listTabs.active && "active"
              }`}
              style={{ padding: "19px 10px" }}
            >
              My Groups
            </b>
            {isAdmin && (
              <b
                onClick={() => {
                  setListTabs((prev) => {
                    return { prev, default: true };
                  });
                  getDefaultGroupList();
                }}
                className={`px-3 border-bottom  tab mb-0  ${
                  listTabs.default && "active"
                }`}
                style={{ padding: "19px 10px" }}
              >
                Default
              </b>
            )}
            {!isAdmin && (
              <b
                onClick={() => {
                  setListTabs((prev) => {
                    return { prev, assigned: true };
                  });
                  getGroupLists("&myassign=true");
                }}
                className={`px-3 border-bottom  tab mb-0  ${
                  listTabs.assigned && "active"
                }`}
                style={{ padding: "19px 10px" }}
              >
                Assigned
              </b>
            )}
            <b
              onClick={() => {
                setListTabs((prev) => {
                  return { prev, archived: true };
                });
                getArchiveList();
              }}
              className={`px-3 border-bottom  tab mb-0  ${
                listTabs.archived && "active"
              }`}
              style={{ padding: "19px 10px" }}
            >
              Archived
            </b>
          </div>
          <div className="actsearch_simple me-2 w-25 mb-2">
            <FiSearch className="boxicon" />
            <input
              placeholder="Search for group..."
              className="ms-2"
              // value={searchText}
              onChange={(e) => onGroupSearch(e)}
            />
          </div>
        </div>

        {/* Active Tab */}
        {listTabs.active && (
          <table class="table table-hover">
            <thead>
              <tr className="">
                <td className="py-4 col-1">Thumbnail</td>
                <td className="py-4">Group Title</td>
                <td className="py-4 ">Group Description</td>
                <td className="py-4 ">Created At</td>
                <td className="py-4 col-2">No of Participants</td>
                <td className="py-4">Action</td>
              </tr>
            </thead>
            {renderList()}
          </table>
        )}

        {/* Default Tab */}
        {listTabs.default && (
          <table class="table table-hover">
            <thead>
              <tr>
                <td className="py-4 col-1">Thumbnail</td>
                <td className="py-4">Group Title</td>
                <td className="py-4">Group Description</td>
                <td className="py-4">Created At</td>
                <td className="py-4 col-2">No of Participants</td>
                <td className="py-4">Action</td>
              </tr>
            </thead>
            {DefaultrenderList()}
          </table>
        )}

        {/* Assigned Tab */}
        {listTabs.assigned && (
          <table class="table table-hover">
            <thead>
              <tr>
                <td className="py-4 col-1">Thumbnail</td>
                <td className="py-4">Group Title</td>
                <td className="py-4">Group Description</td>
                <td className="py-4">Created At</td>
                <td className="py-4 col-2">No of Participants</td>
                <td className="py-4">Action</td>
              </tr>
            </thead>
            {AssignedrenderList()}
          </table>
        )}

        {/* Archived Tab */}
        {listTabs.archived && (
          <table class="table table-hover">
            <thead>
              <tr>
                <td className="py-4 col-1">Thumbnail</td>
                <td className="py-4">Group Title</td>
                <td className="py-4">Group Description</td>
                <td className="py-4">Created At</td>
                <td className="py-4 col-2">No of Participants</td>
                <td className="py-4">Action</td>
              </tr>
            </thead>
            {ArchivedrenderList()}
          </table>
        )}
        <AssignProvidersModal
          addMember={updateGroup}
          members={groupProviders}
          setMembers={setGroupProviders}
        />
        {!filterdata?.length ? renderLoader() : null}
      </div>

      {/* <div className="memberside_list" style={{ height: "84vh" }}> */}
      {/* <div className="row">
                    <div className="col-md-12">
                        <div className="actsearch_box1">
                            <FiSearch className="boxicon" />
                            <input
                                placeholder="Search Groups"
                                onChange={(e) => onGroupSearch(e)}
                            />
                        </div>
                    </div>
                    <div className="col-md-12">
                        <div className="memlist_scroll mt-4 spacing_scroll">

                            {isLoading ? (
                                <center>

                                    <Loader
                                        visible={isLoading}
                                        style={{ top: "48px", position: "relative" }}
                                    />
                                </center>
                            ) :
                                filterdata?.length ? (
                                    filterdata?.map((dt, index) => {
                                        console.log(filterdata, "groupLists")
                                        return (
                                            <div
                                                key={dt?._id}
                                                // className="shadow-sm border ms-2 rounded mb-3 p-1"
                                                // onClick={() => {
                                                // }}
                                                className={`card mb-2 p-1 ${props?.selectedGroup?._id == dt?._id ? "active" : ""}`}
                                                onClick={(e) => {
                                                    props.onselectgroup(dt);
                                                    // activeSelection(e);
                                                }}
                                                id={dt._id}
                                            >
                                                <div className="row">
                                                    <div className="col-md-4 p-0 actlist_wid1 d-flex justify-content-center align-items-center">
                                                        <img src={dt.groupImage && dt.groupImage} onError={(e) => {
                                                            e.target.src = "images/avatar.png" //replacement image imported above
                                                        }} alt="" className="member_listimage" />
                                                    </div>
                                                    <div className="col-md-8 actlist_wid2 p-0">
                                                        <p className="mb-0 py-3">
                                                            {`${dt.groupName}`}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })
                                ) : (
                                    <p className="p-2">No data found!</p>
                                )}
                        </div>
                    </div>
                </div> */}
      {/* </div> */}
    </>
  );
};

export default GroupLists;
